import { SxProps } from '@mui/material';

export const OrganCardStyles = {
  container: {
    aspectRatio: '4 / 3',
    borderRadius: { xs: '15px', md: '20px' },
    background: '#ffffff',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.8)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
    overflow: 'hidden',
    '&:hover': {
      transform: 'translateY(-8px) scale(1.02)',
      boxShadow: '0 20px 40px rgba(102, 126, 234, 0.2)',
      cursor: 'pointer',
    },
    '&:active': {
      transform: 'translateY(-4px) scale(1.01)',
    },
  },
  organText: {
    fontSize: { xs: '1rem', sm: '1.05rem', md: '1.1rem' },
    fontWeight: 600,
    color: 'rgb(15, 7, 33)',
    display: 'flex',
    padding: { xs: '15px 15px 8px 15px', md: '20px 20px 10px 20px' },
    position: 'relative',
    zIndex: 1,
    textAlign: 'center',
    justifyContent: 'center',
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: { xs: '8px 0', md: '10px 0' },
    position: 'relative',
    zIndex: 1,
    '& img': {
      transition: 'transform 0.3s ease',
      width: { xs: '100px', sm: '110px', md: '120px' },
      height: { xs: '100px', sm: '110px', md: '120px' },
    },
  },
  progressContainer: {
    padding: { xs: '0 15px 15px 15px', md: '0 20px 20px 20px' },
    position: 'relative',
    zIndex: 1,
  },
  progressRow: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: '8px', md: '12px' },
  },
  progressBar: {
    height: { xs: '8px', md: '10px' },
    borderRadius: { xs: '6px', md: '8px' },
    backgroundColor: 'rgba(102, 126, 234, 0.15)',
    flex: 1,
    overflow: 'hidden',
    '& .MuiLinearProgress-bar': {
      background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
      borderRadius: { xs: '6px', md: '8px' },
    },
  },
  percentageText: {
    fontSize: { xs: '0.75rem', md: '0.85rem' },
    fontWeight: 600,
    color: 'rgb(102, 126, 234)',
    minWidth: 'fit-content',
  },
  starEmoji: {
    fontSize: { xs: '1rem', md: '1.2rem' },
    marginLeft: '4px',
    animation: 'pulse 2s infinite',
    '@keyframes pulse': {
      '0%': {
        transform: 'scale(1)',
      },
      '50%': {
        transform: 'scale(1.1)',
      },
      '100%': {
        transform: 'scale(1)',
      },
    },
  },
} satisfies Record<string, SxProps>;
